import React from 'react';

import { FormattedMessage } from 'react-intl';

import { SearchError } from 'src/types/search';
import urls from 'src/urls/search';

import EmptyState, { EmptyStateProps } from '../empty-state/empty-state';
import errorImgUrl from '../search-error.svg';

import searchBackendErrors from './search-backend-errors.i18n';
import messages from './search-error.i18n';

type SearchErrorProps = {
  response: SearchError;
};

export const SearchErrorState = (props: SearchErrorProps) => {
  const { response } = props;

  const emptyStateProps: Partial<EmptyStateProps> = {
    descriptionMessage: undefined,
    plainDescription: undefined,
  };

  let emptyStateLink;

  if (
    response.error.data &&
    response.error.data.key &&
    // @ts-ignore TODO: fix noImplicitAny error here
    searchBackendErrors[response.error.data.key]
  ) {
    const errorKey = response.error.data.key;
    // @ts-ignore TODO: fix noImplicitAny error here
    emptyStateProps.descriptionMessage = searchBackendErrors[errorKey];
    if (
      errorKey === 'QUERY_WITHOUT_TERMS' ||
      errorKey === 'QUERY_WITHOUT_POSITIVE_TERMS'
    ) {
      emptyStateLink = (
        <a href={urls.external.docs}>
          <FormattedMessage {...messages.learnMoreLink} />
        </a>
      );
    }
  } else {
    emptyStateProps.plainDescription = response.error.message;
  }

  return (
    <EmptyState
      headingMessage={messages.error}
      imageSrc={errorImgUrl}
      {...emptyStateProps}
    >
      {emptyStateLink}
    </EmptyState>
  );
};
